module.exports = __webpack_public_path__ + "img/screen-img-01.dcd1820f.jpeg";